module.exports = __webpack_public_path__ + "static/img/Lachie_Whitfield_desktop.dcf7b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie_Whitfield_desktop.jpg
// module id = 6Djj
// module chunks = 0